package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ItemCategory {
    @SerialName("WEAPON")
    WEAPON,

    @SerialName("EQUIPMENT")
    EQUIPMENT,

    @SerialName("CONSUMABLE")
    CONSUMABLE,

    @SerialName("MAP")
    MAP,

    @SerialName("CLUE")
    CLUE,

    @SerialName("OTHER")
    OTHER
}
